import {ILeaderboardTeamItem} from '@/types/ws.types'
import {
  ESprintenTeam,
  SprintenTeamsLogoMap,
} from '@repo/shared/Customer/Coop/SprintenTeams/SprintenTeams.types'
import clsx from 'clsx'
import {FC} from 'react'

interface ITeamCountProps {
  team: ILeaderboardTeamItem
}

export const TeamCount: FC<ITeamCountProps> = ({team}) => {
  return (
    <div className="team-counter-item flex h-[40px] flex-row gap-[16px]">
      <div
        className={clsx(
          'flex size-[40px] rounded-[12px] border-[3px] border-white',
          team.team === ESprintenTeam.Anglamark && 'bg-team-anglamark',
          team.team === ESprintenTeam.CoopMega && 'bg-team-coop_mega',
          team.team === ESprintenTeam.CoopPrix && 'bg-team-coop_prix',
          team.team === ESprintenTeam.Extra && 'bg-team-extra',
          team.team === ESprintenTeam.OBS && 'bg-team-obs',
        )}
      >
        <img className="team-logo" src={SprintenTeamsLogoMap[team.team]} alt="" />
      </div>
      <div className="team-counter flex h-full w-fit items-center justify-start text-[32px] font-bold leading-none text-white">
        {team.playerCount}
      </div>
    </div>
  )
}
